import {getUserApiData} from "../../utils/UserUtils";
import {invokeApig} from "../../libs/awsLib";
import Paths from "../paths";
import {myID} from "../../libs/generateID";
import store from "../../store/store";
import {notify} from "reapop";
import i18n from "../../i18n";

export function createSowCycles(data, {FarmID, ClientID, LocalUserID} = {}) {
    const {_FarmID, _LocalUserID, _ClientID} = getUserApiData({FarmID, ClientID, LocalUserID});
    return invokeApig({
        ...Paths.createSowCycles({farmID: _FarmID, clientID: _ClientID, localUserID: _LocalUserID}),
        body: data
    });
}

export function createSowCyclesNotificationSuccess(response, {uniqueId = myID()} = {}) {
    store.dispatch(notify({
        id: uniqueId,
        title: i18n.t("apiNotifications.createSowCyclesTitle"),
        message: i18n.t("apiNotifications.createSowCyclesSuccess"),
        status: "success",
        dismissible: true,
        dismissAfter: 5000
    }));
}

export function createSowCyclesNotificationFailure(response, {uniqueId = myID()} = {}) {
    store.dispatch(notify({
        id: uniqueId,
        title: i18n.t("apiNotifications.createSowCyclesTitle"),
        message: i18n.t("apiNotifications.createSowCyclesFailure"),
        status: "error",
        dismissible: true,
        dismissAfter: 15000
    }));
}
